var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.city)
    ? _c(
        "div",
        { staticClass: "categ_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "ct",
              f_type: "title",
              is_disabled: false,
              f_title: _vm.__t("NAME"),
              f_val: _vm.cur_city.title,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid",
              f_type: "uniq_id",
              is_disabled: false,
              f_title: _vm.__t("UNIQ_PROV_CODE"),
              f_val: _vm.cur_city.uniq_id,
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cid3",
              f_title: _vm.__t("UNIQ_ID_CODE"),
              f_val: _vm.cur_city.id.toString(),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "name-f" } },
              [_vm._v(_vm._s(_vm.__t("DATE_CREATE")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_city.added,
                    expression: "cur_city.added",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "name-f", disabled: "" },
                domProps: { value: _vm.cur_city.added },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_city, "added", $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cur_city.updateAt,
                    expression: "cur_city.updateAt",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text", id: "name-l", disabled: "" },
                domProps: { value: _vm.cur_city.updateAt },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.cur_city, "updateAt", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text text-success" }, [
        _c("i", { staticClass: "fal fa-calendar-edit fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }